import { useCallback, useEffect } from 'react';
import { EVENT_NAME_MAP } from '../utils/constants';
import { useEventListener } from './useEventListener';
export const useElementCenter = (elementRef, parentRef) => {
    const onItemCenter = useCallback(() => {
        const element = elementRef.current;
        const container = parentRef.current;
        if (!element || !container) {
            return;
        }
        const position = element.offsetLeft - container.clientWidth / 2 + element.clientWidth / 2;
        container.scrollTo({
            top: 0,
            left: position,
            behavior: 'smooth',
        });
    }, [elementRef, parentRef]);
    useEffect(() => {
        onItemCenter();
    });
    useEffect(() => {
        onItemCenter();
    }, [onItemCenter]);
    useEventListener(elementRef.current, EVENT_NAME_MAP.click, onItemCenter);
};
